<div>
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>{{ title }}</h2>
  </div>

  <main class="form-signin border p-4 rounded">
    <form [formGroup]="workOrderForm" (ngSubmit)="submit()">
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control" id="workOrderId" formControlName="workOrderId" />
            <label for="workOrderId">WO Id</label>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-floating">
            <select formControlName="workOrderCompanyId" id="workCompanyId" class="form-control"
              [class.is-invalid]="submitted && workOrderForm.get('workOrderCompanyId')?.errors">
              <option value="" disabled>Select Company</option>
              <option *ngFor="let company of masterCommonServices?.clientsList" [value]="company.id">
                {{ company.companyName }}
              </option>
            </select>
            <label for="workCompanyId">Company</label>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control" id="poNumber" formControlName="poNumber" />
            <label for="poNumber">PO No</label>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-floating">
            <input type="date" class="form-control" id="workOrderDate" formControlName="workOrderDate" />
            <label for="workOrderDate">Date</label>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="form-floating">
            <textarea class="form-control" id="remarks" formControlName="remarks"
              placeholder="Enter remarks"></textarea>
            <label for="remarks">Remarks</label>
          </div>
        </div>
      </div>


      <div class="col-md-12 mt-5">
        <h3><strong>Work Items Preview</strong></h3>
      </div>

      <div class="border p-2 rounded">
        <div class="row mb-3">
          <div class="col-md-12">
            <button type="button" class="btn btn-primary mb-3" (click)="addRow()">Add Row</button>

            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th class="col-sr-no">Sr No</th>
                  <th class="col-part-number">Part No</th>
                  <th class="col-description">Description</th>
                  <th class="col-quantity">Qty</th>
                  <th class="col-unit">
                    Unit
                    <div class="mt-2">
                      <button type="button" class="btn btn-sm btn-primary" (click)="openAddUpdateUnitDialog()"
                        title="Add Unit">
                        +
                      </button>
                    </div>
                  </th>
                  <th class="col-dispatched-qty">Dispatched Qty</th>
                  <th class="col-actions">Actions</th>
                </tr>
              </thead>

              <tbody formArrayName="workItems">
                <ng-container *ngFor="let item of workItems.controls; let i = index" [formGroupName]="i">
                  <tr *ngIf="item.get('isDeleted')?.value !== true">
                    <td>
                      <input type="text" class="form-control" formControlName="srNo" />
                    </td>

                    <td>
                      <input #partInput type="text" class="form-control" placeholder="Type or select Part No"
                        [value]="getPartNameById(item.get('partNumberId')?.value)"
                        (input)="onPartNumberInput(partInput.value, i)" (focus)="onPartNumberFocus(i)"
                        (blur)="onPartNumberBlur(i)" [matAutocomplete]="auto" />

                      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="onPartNumberSelected($event.option.value, i)">
                        <mat-option *ngFor="let part of filteredPartNumbers[i]" [value]="part.partName">
                          {{ part.partName }}
                        </mat-option>
                      </mat-autocomplete>
                    </td>
                    <td class="col-description">
                      <textarea class="form-control auto-resize" formControlName="description" rows="1"
                        (input)="autoResize($event)">
                      </textarea>
                    </td>
                    <td>
                      <input type="number" class="form-control" formControlName="quantity" />
                    </td>
                    <td>
                      <select class="form-control" formControlName="unit">
                        <option value="" disabled>Select Unit</option>
                        <option *ngFor="let unit of masterCommonServices.unitsList" [value]="unit.id">
                          {{ unit.unitName }}
                        </option>
                      </select>
                    </td>

                    <td>
                      <input type="number" class="form-control" formControlName="dispatchedQuantity" />
                    </td>
                    <td class="col-actions">
                      <button type="button" class="btn btn-danger btn-sm" (click)="removeRow(i)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary" [disabled]="workOrderForm.invalid || workOrderForm.pristine">Submit</button>
        </div>
      </div>
    </form>
  </main>
</div>
